// Reusable device mockup frames (CSS-based). Images fill the "screen".

export const PhoneFrame = ({ src, alt, className = "" }) => (
  <div className={className}>
    <div className="bg-[#1f2937] rounded-[1.6rem] p-[5px] shadow-[0_20px_45px_rgb(0,0,0,0.22)]">
      <div className="relative overflow-hidden rounded-[1.25rem] bg-white aspect-[9/19]">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[38%] h-3 bg-[#1f2937] rounded-b-xl z-10" />
        <img src={src} alt={alt} loading="lazy" className="w-full h-full object-cover object-top" />
      </div>
    </div>
  </div>
);

export const TabletFrame = ({ src, alt, className = "" }) => (
  <div className={className}>
    <div className="relative bg-[#1f2937] rounded-[1.2rem] p-2 shadow-[0_22px_50px_rgb(0,0,0,0.20)]">
      <div className="absolute top-[7px] left-1/2 -translate-x-1/2 w-1.5 h-1.5 rounded-full bg-[#3b4658] z-10" />
      <div className="relative overflow-hidden rounded-[0.7rem] bg-white aspect-[3/4] mt-2">
        <img src={src} alt={alt} loading="lazy" className="w-full h-full object-cover object-top" />
      </div>
    </div>
  </div>
);

export const LaptopFrame = ({ src, alt, className = "" }) => (
  <div className={className}>
    <div className="bg-[#1f2937] rounded-t-xl p-[6px] pb-1 shadow-[0_20px_45px_rgb(0,0,0,0.20)]">
      <div className="overflow-hidden rounded-md bg-white aspect-[16/10]">
        <img src={src} alt={alt} loading="lazy" className="w-full h-full object-cover object-top" />
      </div>
    </div>
    <div className="relative mx-auto -mt-px" style={{ width: "116%", marginLeft: "-8%" }}>
      <div className="h-2.5 bg-gradient-to-b from-[#2b3648] to-[#1a222f] rounded-b-xl" />
      <div className="h-1 w-1/5 mx-auto bg-[#111827] rounded-b-md" />
    </div>
  </div>
);
